import { app } from "@/modules/app";
import { useStackRouteComponent } from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
  {
    parent: 'public',
    path: '/auth',
    component: useStackRouteComponent(() => import('@/pages/personal/auth.dialog.vue'))
  }
]);
